<template>
  <div class="grid grid-cols-12">
    <div class="col-span-12 intro-y">
      <button
        v-if="!all"
        @click="changeReport(true)"
        class="button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10"
      >
        Ver {{ team_session == 1 ? 'todos los proyectos' : 'todas las cuenta' }}
      </button>
      <button
        v-else
        @click="changeReport(false)"
        class="button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10"
      >
        Ver solo {{ team_session == 1 ? 'un proyecto' : 'una cuenta' }}
      </button>
    </div>
    <TasksMonthsAccount v-if="!all" />
    <TasksAccounts v-else />
  </div>
</template>

<script>
import Loading from '@/components/admin/partials/LoadingWhite'
import TasksAccounts from './partials/TasksAccounts.vue'
import TasksMonthsAccount from './partials/TasksMonthsAccount.vue'

export default {
  name: 'ReportTasks',
  data() {
    return {
      loading: false,
      all: false,
      team_session: null,
      account_session: null,
    }
  },
  async beforeMount() {
    this.account_session = localStorage.session_account
    this.team_session = localStorage.session_team
  },
  methods: {
    changeReport(value) {
      this.all = value
    },
  },
  components: {
    TasksMonthsAccount,
    TasksAccounts,
    Loading,
  },
}
</script>



// WEBPACK FOOTER //
// ReportTasks.vue?75bc5f80